var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgCreateFile = function SvgCreateFile(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11,
    height: 12,
    fill: "none",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 0.75,
    d: "M5.606 11.429H1.143A1.14 1.14 0 0 1 0 10.286V1.143C0 .514.509 0 1.143 0h4.571l3.429 3.429v2.908a4 4 0 0 0-.572-.051c-.194 0-.382.023-.571.051V4H5.143V1.143h-4v9.143h4.051c.069.411.212.794.412 1.143m5.251-2.286H9.143V7.429H8v1.714H6.286v1.143H8V12h1.143v-1.714h1.714z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgCreateFile);
export { ForwardRef as ReactComponent };